module.exports = __webpack_public_path__ + "media/images/workplace/activity_points/index_main_bg-4eecdc3d59331e999b485d79d3b14537.png";